module.exports = __webpack_public_path__ + "static/media/Group.bc07c3a9.png";